<template>
  <w-textarea :model="schema.reason" />
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Formularz uzasadnienia
// @group ActionData
export default {
  components,
  props: {
    // schema
    schema: { type: Object, required: true }
  }
};
</script>
